import { Component, OnInit, Inject, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/auth.service';
import { BaseService } from '../../shared/base.service';
import { AppService } from '../../app.service';
import { PopoverService } from '../../shared/popover/popover.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { PDFsService } from './pdfs.service';
import { DialogComponent } from '../../dialog/dialog.component';
import { Subscription } from 'rxjs';
import { VideosComponent } from '../video/videos.component';
import { VideosService } from '../video/videos.service';

@Component({
    selector: 'pdfs-component',
    templateUrl: 'pdfs.component.html',
    styleUrls: ['pdfs.component.scss'],
    providers: [
        PDFsService,
        VideosService
    ]
})

export class PDFsComponent extends VideosComponent implements OnInit, OnDestroy {
    successMessage: string = '';
    allPDFs: any;
    searchTerms: string = '';
    clinicId = 0;
    clinic: any;
    pdfs = [];
    language = 'DE';
    searchInfo = {keyword: ''};
    subscribe: Subscription;
    queryParams: any;
    languages = [];

    @ViewChild(DialogComponent, {static: false}) dialog: DialogComponent;

    constructor(public authService: AuthService,
                public router: Router,
                public baseService: BaseService,
                public pdfsService: PDFsService,
                public videosService: VideosService,
                public appService: AppService,
                public popoverService: PopoverService,
                public route: ActivatedRoute) {
        super(authService, router, baseService, videosService, appService, popoverService, route);
    }

    ngOnInit() {
        this.subscribe = this.route.queryParams.subscribe(params => {
            this.queryParams = params;
            if(params['lang']) {
                this.language = params['lang'];
            }
        });
        this.languages = JSON.parse(localStorage.getItem('languages'));
        this.getData();
    }
    ngOnDestroy() {
        if (this.subscribe) {
            this.subscribe.unsubscribe();
        }
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.pdfs, event.previousIndex, event.currentIndex);
        this.pdfsService.order(this.pdfs, event.previousIndex, event.currentIndex, this.language).subscribe(
            (response) => {
            });
    }

    getData() {
        this.appService.isLoading = true;
        this.pdfsService.all(this.language).subscribe((response) => {
            this.appService.isLoading = false;
            if (!response['pdfs'].length) {
                this.pdfs = [];
                return;
            }
            const pdfs = response['pdfs'].filter(
                item => item['title'].indexOf(this.searchInfo.keyword) >= 0
            );
            this.pdfs = pdfs;
        });
    }

    selectPDFBylanguage(language) {
        this.language = language;
        this.router.navigate(['support/pdfs'], { queryParams: {lang : language}});
        return this.getData();
    }
}
